import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateEstimateBasicInfo } from '../../../../../services/ContractService/contractEstimateSlice';

export const EstimateServiceDateEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const estimate = useAppSelector(state => state.contractEstimate.currentEstimate);
  const errors = useAppSelector(state => state.contractEstimate.validationErrors);

  // Format date from API format to input format (YYYY-MM-DD)
  const formatDateForInput = (dateString: string | undefined): string => {
    if (!dateString) return '';
    try {
      // Extract just the date part from ISO string (e.g., "2024-01-15T00:00:00" -> "2024-01-15")
      return dateString.split('T')[0];
    } catch {
      return '';
    }
  };

  const handleServiceDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateEstimateBasicInfo({
      serviceDate: e.target.value
    }));
  };

  return (
    <TextField
      label="Service Date"
      type="date"
      value={formatDateForInput(estimate?.serviceDate)}
      onChange={handleServiceDateChange}
      required
      error={!!errors.serviceDate}
      helperText={errors.serviceDate}
      InputLabelProps={{ shrink: true }}
      size="small"
      sx={{ width: 160 }}
    />
  );
};